export enum ProcoreEntityConfigurationProjectFilters {
    Type = "T",
    Category = "C"
}

export let nameof = "ProcoreEntityConfigurationProjectFilters";
